// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__q2nhg","balanceDisclaimer":"posDashboard_balanceDisclaimer__3ojTK"};